// @ts-strict-ignore
import getLength from 'utf8-byte-length';

import { isNotEmpty } from 'utils/functional';

function isLowSurrogate(codePoint) {
  return codePoint >= 0xdc00 && codePoint <= 0xdfff;
}

// Truncate `s` so that its utf-8 representation contains no more than
// `maxbytes` bytes.
export function truncateToUTF8Bytes(s: string, maxbytes: number) {
  while (getLength(s) > maxbytes) {
    if (isLowSurrogate(s.charCodeAt(s.length - 1))) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
      s = s.substr(0, Math.max(s.length - 2, 0));
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
    } else s = s.substr(0, s.length - 1);
  }

  return s;
}
export function truncateToWords(
  string: string,
  maxwords: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: Record<string, any>
) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-param-reassign
  options = options || {
    ellipsis: false,
  };
  const truncatedWords = string.split(' ').splice(0, maxwords);
  const truncated = truncatedWords.join(' ');
  return options.ellipsis && string.split(' ').length > truncatedWords.length
    ? `${truncated}...`
    : truncated;
}

export function camelCaseToDash(string: string) {
  return string.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
}

export function camelCaseToSnakeCase(string: string) {
  return string.replace(/([a-zA-Z])(?=[A-Z])/g, '$1_').toLowerCase();
}

export function snakeCaseToCamelCase(string: string) {
  return string.replace(/_([a-zA-Z])/g, (m) => m[1].toUpperCase());
}

export function titleCaseToCamelCase(string: string) {
  return string.toLowerCase().replace(/(_\w)/g, (m) => m[1].toUpperCase());
}

export function makeAbsolutePath(url: string) {
  return url[0] === '/' ? url : `/${url}`;
}
export const minLengthFn = (n: number) => (s: string) =>
  isNotEmpty(s) && s.toString().trim().length >= n;

export function convertToSlug(text: string) {
  return text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/^-+/, '')
    .replace(/--+/g, '-')
    .replace(/-+$/, '');
}
